export default __webpack_public_path__ + "static/media/icon-lixeira.9e1fe2bf.svg";